import React from "react"
import {RefTable, DefaultProps, Validator} from "../RefTable"

export const ReportingFeeClasses = (props)=><RefTable {...props}/>;

ReportingFeeClasses.defaultProps = {
    ...DefaultProps,
    title: "Reporting Fees",
    tableSchema: "em_reporting_fee_type",
    tableName: "em_reporting_fee_type",
    edit: true,
    validator: {
        value: new Validator("value", async (value)=> {
            if(value < 0 )
                return Promise.reject("Duty cannot be negative")
        })
    },
}
